module.exports = __webpack_public_path__ + "img/security-stability-mobile-en.53696e6b.png";